// extracted by mini-css-extract-plugin
module.exports = {"skeletonLoader":"SkeletonLoader_skeletonLoader__88umP","shine":"SkeletonLoader_shine__vkwxJ","skeletonLoader__single":"SkeletonLoader_skeletonLoader__single__v42vO"};